export default {
  page: {
    title: "Password",
  },

  footer: {
    icon: [],
    link: [],
  },
}
